<template>
  <div id="newsletter-top" class="flex flex-col pb-0 xs:pb-0 px-4">
    <div class="">
      <div class="flex flex-col items-center justify-center">
        <div class="w-full container mx-auto">
          <img class="w-full hidden sm:block" :src="require('images/newsletter_page/img1.png')" />
          <img class="w-full block sm:hidden" :src="require('images/newsletter_page/img2.png')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "section1",
  data() {
    return {
    };
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>